<template>
    <div 
        @click="handleClicks" class="html-content" role="content"
        v-if="html" 
        ref="htmlContent"
        v-once
        v-html="html" >
    </div>
    <div 
        @click="handleClicks" 
        class="html-content" 
        role="content"  
        ref="htmlContent"
        v-html="htmlSlot"
        v-once
        v-else>
    </div>
</template>


<script>

import { mapGetters } from 'vuex'

export default {
    name: 'dynamic-html',
    props : ['html'],
    computed:{
        htmlSlot(){
            if(typeof this.$slots.default  !== "undefined"  && this.$slots.default[0]){
                return this.$slots.default[0].text
            }
            return null;
        },
        ...mapGetters([
			'pageIsLoading',
		]),
    },
    components:{
    },
    mounted(){
        const VM = this;
        VM.$nextTick(()=>{
            if(!VM.pageIsLoading){
                VM.triggerLoadForm()
            }else{
                setTimeout( () => {
                    VM.triggerLoadForm()
                }, 200)
            }
                
        })
    },
    methods:{
        triggerLoadForm(){
            const VM = this;
            const content = VM.$refs.htmlContent;
            if(content){
                let gravityForm = jQuery(content).find('.call-gf-form');
                if(gravityForm.length > 0){
                    gravityForm.each( (i, form) => {
                        VM.loadGravityForm(form);
                    });
                }
            }
        },
        loadGravityForm(gformLoader){
            const VM = this;
            const fromID = jQuery(gformLoader).attr('data-form');
            const container = VM.$refs.htmlContent;
			jQuery(container).find('#gf_button_form_container_'+fromID).html('<div class="loading-form"><span class="icon">'+VM.svgIcons.preloader+'</span><span class="text">Loading form ...</span><//div>').fadeIn();
			jQuery.get(WPVUE.ajaxurl + '?action=gf_button_get_form&form_id=' + fromID, function (response) {
				jQuery(container).find('#gf_button_form_container_' + fromID).html(response);
				jQuery(gformLoader).remove();
				if (window['gformInitDatepicker']) { gformInitDatepicker(); }
            });
        },
        /**
         * JS has better support when a parent is a tag instead od current event target
         */
        handleClicksJQ(){
            $( ".html-content a").click(function(e){
                e.preventDefault();
                if (target && target.tagName === 'A' && target.href) {}
                //alert("yes link clicked");
            });
        },
        handleClicks ($event) {
            const { target } = $event
            
            // check if maybe parent is a link - some time it is the thing;
            const link = (target.href)? target : (target.closest('a') && target.closest('a').href )? target.closest('a') : null;
            // handle only links that occur inside the component and do not reference external resources
            if (target && link) {
            // some sanity checks taken from vue-router:

                // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
                const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = $event
                // don't handle with control keys
                if (metaKey || altKey || ctrlKey || shiftKey) return
                // don't handle when preventDefault called
                //if (defaultPrevented) return

                // don't handle right clicks
                if (button !== undefined && button !== 0) return

                // don't handle if `target="_blank"`
                if (link && link.getAttribute) {
                    const linkTarget = link.getAttribute('target')
                    if (/\b_blank\b/i.test(linkTarget)) return
                }
                // don't handle same page links/anchors
                const home = WPVUE.home_url;
                const url = new URL(link.href)
                const to = url.pathname
                const mediaUrl = home+'/media/';
                if (    window.location.pathname !== to && $event.preventDefault 
                    && ( url.origin.replace(/\/$/, "") === home.replace(/\/$/, "") )
                    && ( url.href.indexOf(mediaUrl) === -1 )
                ){
                    $event.preventDefault();
                    this.$router.push(to)
                }
            }
        } 
    }
    
}
</script>